import Components from './../Component';

export default class FloatingHelper extends Components {

  constructor($) {
    super($);
  }

  init(index, element) {
    jQuery(element).find('a').on('click', function(e){
      e.preventDefault();
      jQuery(element).remove();
    });
  }
}